import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    OnDestroy,
    Output,
    SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { GlobalFilterColor, GlobalFilterProperty } from '../global-filters-types.enum';
import { Filter } from '../table-filter/filter';
import { FilterBase } from '../table-filter/filter-base';
import { AppScope } from '@klickdata/core/resource';

@Component({
    selector: 'app-table-search',
    templateUrl: './table-search.component.html',
    styleUrls: ['./table-search.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [{ provide: FilterBase, useExisting: TableSearchComponent }],
})
export class TableSearchComponent extends FilterBase implements OnDestroy, OnChanges, OnInit {
    @Input() inGlobalFilter: boolean;
    @Input() toggleBtnLabel = $localize`Title`;
    @Input() placeHolder = $localize`Filter by name...`;
    @Input() ignoreCaching: boolean;
    @Input() minQueryCharLength = 3;
    @Output() filterChange: EventEmitter<Filter<string>> = new EventEmitter<Filter<string>>();
    @Output() filterRemoval: EventEmitter<Filter<string>> = new EventEmitter<Filter<string>>();
    /** @Deprecated with filterChange to follow table filter structure */
    // @Output() search: EventEmitter<string> = new EventEmitter();
    protected _filter: Filter<string> = {
        property: GlobalFilterProperty.SEARCH,
        items: [],
        label: this.toggleBtnLabel,
        isMultiple: false,
        icon: 'search',
        color: { bg: GlobalFilterColor.C1, fg: GlobalFilterColor.WHITE },
        styleClass: 'global-search-filter-selector',
    };

    public control: FormControl = new FormControl();
    public searchSubscription: Subscription;
    public never = 'never';

    constructor(protected cdRef: ChangeDetectorRef) {
        super();
        this.searchSubscription = this.control.valueChanges
            .pipe(
                filter((query) => !query?.length || query.length >= this.minQueryCharLength),
                filter(() => !this.filter.isMultiple),
                debounceTime(300),
                distinctUntilChanged()
            )
            .subscribe((search) => {
                this._filter.items = search ? [search] : [];
                // this.search.emit(search);
                if (search) {
                    this.filterChange.emit(this.filter);
                } else {
                    this.filterRemoval.emit(this.filter);
                }
                this.cdRef.detectChanges();
            });

        // this.cacheScope = AppScope.ALL;
    }
    ngOnInit(): void {
        this.filter.isMultiple = !!this.filter.items && this.filter.items.length > 0;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.toggleBtnLabel) {
            this._filter.label = changes.toggleBtnLabel.currentValue;
        }
    }
    public sendSearchQuery(query: string): void {
        if (!!query?.length && query.length >= this.minQueryCharLength) {
            this.filter.isPartialRemove = false;
            this._filter.items = [...this._filter.items, query];
            this.filterChange.emit(this.filter);
            this.control.setValue('');
            this.cdRef.detectChanges();
        }
    }
    protected ignoreCache(): boolean {
        return this.ignoreCaching;
    }
    public ngOnDestroy(): void {
        if (this.searchSubscription) {
            this.searchSubscription.unsubscribe();
            this.searchSubscription = null;
        }
    }

    public clear() {
        this.control.setValue('');
        this.filter.items = [];
        this.filterRemoval.emit(this.filter);
        this.filter.isPartialRemove = false;
    }
    public setQuery(query: string): void {
        this.control.setValue(query);
    }
    public get filter(): Filter<string> {
        return this._filter;
    }
    protected setFilterItems(items: any) {
        this.filter.items = this.filter.isMultiple ? [...new Set([...this.filter.items, ...items])] : items;
    }
    public removeItem(item: string): void {
        this.filter.isPartialRemove = true;
        this.filter.items = this.filter.items.filter((_item) => _item !== item);
        this.filterChange.emit(this.filter);
    }
    public onToggleAdvancedFiltering(isAdvancedFiltering: boolean, isFromCache = false): void {
        this.filter.isMultiple = isAdvancedFiltering;
        this.control.setValue('', { emitEvent: false });
        this.cdRef.detectChanges();
    }
}
